import React, { useContext, useEffect, useState } from "react";
import "./Withdrawal.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Form } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_components/common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import Successfull_Modal from "../../common_components/common_modal/successfull_modal/Successfull_Modal";
import Success_Lottie from "../../animation/success_lottie/Success_Lottie";
import Verification_Steps_Modal from "../../common_components/common_modal/verification_steps_modal/Verification_Steps_Modal";
import Verify_Profile_Modal from "../../common_components/common_modal/verify_profile_modal/Verify_Profile_Modal";
import { useForm } from "react-hook-form";
import { Context } from "../../../utils/context";
import { postWithdrawalMoney } from "../../../utils/apis/withdrawal/withdrawal";
import { ApSetup } from "../../../utils/apis/master/Master";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Withdrawal = () => {
  const navigate = useNavigate();
  const [verify, setVerify] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);

  const { userdata, getuserData } = useContext(Context);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const [appSetup, setAppSetup] = useState({});

  const getAppSetup = async () => {
    const res = await ApSetup();
    if (res?.success) {
      setAppSetup(res.data);
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  useEffect(() => {
    if (userdata?.accept_or_reject === 1) {
      setVerify(true);
    }
  }, [userdata]);

  const onSubmit = async (data) => {
    const payload = {
      amount: data.amount,
      withdrawal_address: data.withdrawal_address.trim(),
      network_crypto: data.network_crypto.trim(),
    };

    try {
      const res = await postWithdrawalMoney(payload);
      if (res?.success) {
        toast.success("Withdrawal request submitted successfully!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });

        getuserData(userdata?.id);
        // setSuccessModal(true);
        setTimeout(() => {
          navigate("/transaction-history");
          // setSuccessModal(false);
        }, 3000);
      } else {
        const msg = res?.message || "Withdrawal failed";
        setError("amount", { message: msg });
        toast.error(msg, { position: "bottom-right" });
      }
    } catch (error) {
      console.error("API Error:", error);
      const errMsg = "An error occurred. Please try again.";
      setError("amount", { message: errMsg });
      toast.error(errMsg, { position: "bottom-right" });
    }
  };

  return (
    <section className="withdrawal-page">
      <ToastContainer position="bottom-right" theme="dark" />

      <div className="header-wrapper">
        <Section_Header_Bar />
      </div>

      <h1 className="page-title">Withdrawal</h1>

      <div className="withdrawal-content">
        <div className="withdrawal-card">
          {(
            <>
              <Form onSubmit={handleSubmit(onSubmit)} className="withdrawal-form">
                <div className="form-grid">
                  {/* Withdrawal Amount */}
                  <div className="form-group">
                    <label className="form-label">Withdrawal Amount (USD)</label>
                    <Form.Control
                      className="modern-input"
                      type="number"
                      step="0.01"
                      placeholder="Enter amount"
                      {...register("amount", {
                        required: "Withdrawal amount is required",
                        min: {
                          value: appSetup.min_withdrawl_amount || 0,
                          message: `Minimum withdrawal is $${appSetup.min_withdrawl_amount}`,
                        },
                        valueAsNumber: true,
                      })}
                    />
                    {errors.amount && (
                      <p className="error-text">{errors.amount.message}</p>
                    )}
                  </div>

                  {/* Withdrawal Address */}
                  <div className="form-group">
                    <label className="form-label">
                      Withdrawal Address <span className="required">*</span>
                    </label>
                    <Form.Control
                      className="modern-input"
                      type="text"
                      placeholder="Enter your wallet address"
                      {...register("withdrawal_address", {
                        required: "Withdrawal address is required",
                        minLength: {
                          value: 20,
                          message: "Address seems too short",
                        },
                      })}
                    />
                    {errors.withdrawal_address && (
                      <p className="error-text">{errors.withdrawal_address.message}</p>
                    )}
                  </div>

                  {/* Network & Crypto */}
                  <div className="form-group full-width">
                    <label className="form-label">
                      Network & Crypto <span className="required">*</span>
                    </label>
                    <Form.Control
                      className="modern-input"
                      type="text"
                      placeholder="e.g., Bitcoin(BTC), Ethereum(ETH), USDT(TRC20), etc."
                      {...register("network_crypto", {
                        required: "Network and crypto name is required",
                      })}
                    />
                    {errors.network_crypto && (
                      <p className="error-text">{errors.network_crypto.message}</p>
                    )}
                  </div>
                </div>

                <div className="fee-info">
                  <p>
                    Minimum withdrawal: <strong>${appSetup?.min_withdrawl_amount || 0}</strong>
                  </p>
                  <p>
                    Withdrawal fee: <strong>{appSetup?.withdrawal_percent || 0}%</strong> will be deducted
                  </p>
                </div>

                <div className="submit-wrapper">
                  <Orange_White_Border_Btn
                    btn_name="Submit Withdrawal"
                    type="submit"
                    className="submit-btn"
                  />
                </div>
              </Form>
            </>
          )}
        </div>

        <div className="footer-text">
          <Inner_Footer_Text_Component />
        </div>
      </div>

      <Verification_Steps_Modal
        modal_title="Withdraw Successfully!"
        show={showModal}
        onHide={() => setShowModal(false)}
        lottie={<Success_Lottie />}
        setShowUploadModal={setShowUploadModal}
      />

      <Verify_Profile_Modal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
      />

      {/* <Successfull_Modal
        message="Withdraw Request Sent Successfully!"
        show={successModal}
        onHide={() => setSuccessModal(false)}
        lottie={<Success_Lottie />}
      /> */}
    </section>
  );
};

export default Withdrawal;